export default __webpack_public_path__ + "static/media/Phone.a43b19a2.svg";